import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-total-sale-per-month',
  templateUrl: './total-sale-per-month.component.html',
  styleUrls: ['./total-sale-per-month.component.scss']
})
export class TotalSalePerMonthComponent implements OnInit {
  monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  month_list_for_last_12_months: any = [];
  selected_month: any;
  is_document_available: boolean = true;
  is_data_available: boolean = true;
  total_sale_details: any;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  title = null;

  constructor(private httpService: HttpService,  private global: GlobalService  ) {
    let today = new Date();
    this.title = this.global._active_display_name;
    today.setDate(1);
    let data_dict = {
      'month_in_string': this.monthNames[today.getMonth()],
      'month_in_integer': today.getMonth(),
      'year': today.getFullYear()
    }
    this.month_list_for_last_12_months.push(data_dict);
    for (let i = 0; i <= 11; i++) {
      today.setMonth(today.getMonth() - 1);
      let data_dict = {
        'month_in_string': this.monthNames[today.getMonth()],
        'month_in_integer': today.getMonth(),
        'year': today.getFullYear()
      };
      this.month_list_for_last_12_months.push(data_dict);
    }
    console.log(this.month_list_for_last_12_months);
  }

  getClicked() {
    let data_dict = {
      'selected_month': this.selected_month['month_in_integer'] + 1,
      'selected_year': this.selected_month['year']
    };
    console.log(data_dict);
    this.is_data_available = false;
    this.httpService.serveTotalSalePerMonthInCounterAsJson(data_dict).subscribe((data) => {
      console.log(data);
      this.total_sale_details = data;
      this.is_data_available = true;
    }, (error) => {
      this.is_data_available = true;
    });
  }

  downloadReportCliked() {
    let data_dict = {
      'selected_month': this.selected_month['month_in_integer'] + 1,
      'selected_year': this.selected_month['year']
    };
    console.log(data_dict);
    this.is_document_available = false;
    this.httpService.serveTotalSalePerMonthInCounter(data_dict).subscribe((data) => {
      console.log(data);
      const linkSource = 'data:application/pdf;base64,' + data['pdf'];
      const downloadLink = document.createElement("a");
      const fileName = data['file_name'];
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      this.is_document_available = true;
    }, (error) => {
      this.is_document_available = true;
    });
  }


  ngOnInit() {
  }

}
